import {transient} from 'quickstart/system'
import {truthy, UnprefixTransientProps} from 'quickstart/types'
import {Children, ComponentProps, forwardRef} from 'react'
import {logger} from 'tizra'
import * as S from './styles'

const log = logger('quickstart/components/layout/Stack')

type StackProps = Partial<
  UnprefixTransientProps<ComponentProps<typeof S.Stack>>
> & {
  capped?: ComponentProps<typeof S.Stack>['$startCapped']
}

export const Stack = forwardRef<any, StackProps>(
  (
    {
      children,
      capped = false,
      startCapped = capped,
      endCapped = capped,
      divided = false,
      row = false,
      spacing = 'md',
      trimMargin = false,
      wrapChildren = true,
      ...props
    },
    ref,
  ) => {
    const $props = transient({
      divided,
      startCapped,
      endCapped,
      row,
      spacing,
      trimMargin,
      wrapChildren,
    })

    const childWrapper = (
      props.as === 'ol' || props.as === 'ul' ? 'li' : 'div'
    ) as 'li' | 'div'

    let childArray = Children.toArray(children)
    childArray = childArray
      .flatMap((child, i) => [
        ((i === 0 && startCapped) || (i > 0 && divided)) && (
          <S.Divider
            key={`divider.${i}`}
            {...$props}
            $first={i === 0}
            $last={false}
          />
        ),
        wrapChildren ? (
          <S.Item key={`item.${i}`} as={childWrapper}>
            {child}
          </S.Item>
        ) : (
          child
        ),
        i + 1 === childArray.length && endCapped && (
          <S.Divider
            key={`divider.${i + 1}`}
            {...$props}
            $first={false}
            $last={true}
          />
        ),
      ])
      .filter(truthy)

    return (
      <S.Stack {...$props} {...props} ref={ref}>
        {childArray}
      </S.Stack>
    )
  },
)
